import { CSSProperties, StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { baseStyles, CssSelectors, truncateTextStyle } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
	},
	selectTrigger: {
		...(baseStyles.textField as CSSProperties),
		height: 30,
		// Fixed width (and no shrink) so the prediction dropdowns line up across rows whether or not
		// the change-reason icon is present beside them.
		width: 120,
		flexShrink: 0,
	},
	selectOption: {
		...CssSelectors.allChildren(
			{
				...truncateTextStyle,
			},
			'.select-box-trigger-content'
		),
	},
	percentageLabel: {
		marginLeft: 8,
		fontWeight: 'bold',
	},
	modal: {
		width: 400,
	},
	modalContent: {
		padding: 20,
	},
	modalTitle: {
		marginTop: 0,
		marginBottom: 16,
		fontSize: 18,
		fontWeight: 'bold',
	},
	modalInstruction: {
		marginBottom: 16,
	},
	input: {
		width: '100%',
		padding: 8,
		marginBottom: 20,
		border: '1px solid #ddd',
		borderRadius: 4,
	},
	modalButtons: {
		alignItems: 'center',
		display: 'flex',
		flex: 2,
		flexDirection: 'row',
		margin: '12px 0',
		maxHeight: 35,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	cancelButton: {
		padding: '8px 16px',
		marginRight: 10,
		border: '1px solid #ddd',
		backgroundColor: '#f5f5f5',
		borderRadius: 4,
		cursor: 'pointer',
	},
	submitButton: {
		padding: '8px 16px',
		backgroundColor: '#0078d4',
		color: 'white',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
	},
	reasonField: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.md,
	},
	reasonFieldLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	requiredMark: {
		color: THEME.colors.danger.main,
		marginLeft: THEME.spacing.xs,
	},
	reasonSelectTrigger: {
		width: '100%',
	},
	errorText: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	dialogFooter: {
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-end',
	},
	reasonIndicatorSlot: {
		alignItems: 'center',
		display: 'inline-flex',
		flexShrink: 0,
		justifyContent: 'center',
		marginLeft: THEME.spacing.xs,
		width: 28,
	},
	reasonPopover: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		maxWidth: 280,
		padding: THEME.spacing.xs,
	},
	reasonPopoverRow: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	reasonPopoverLabel: {
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: THEME.typography.fontWeights.bold,
		textTransform: 'uppercase',
		opacity: 0.6,
	},
	reasonPopoverCategory: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	reasonPopoverDetail: {
		fontSize: THEME.typography.fontSizes.sm,
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
	},
	reasonPopoverEdit: {
		alignSelf: 'flex-start',
	},
});
